module.exports = __webpack_public_path__ + "img/Sanitätstrupp.43664b8d.svg";